import axios from 'axios'
import { LOGINAPI_ADDRESS } from 'config'

interface UsersManagmentObject {
  error: string
  _id?: string // eslint-disable-line
  shortName: string
  userId: string
  isAdmin: string
  role: string
  pic: string
  username: string
  phonenumber: string
  twoFactorType?: string
  councilsAcList?: []
  buildingsAcList?: []
}

interface UsersManagmentAddObject {
  error: string
  shortName: string
  userId: string
  isAdmin: string
  role: string
  pic: string
  username: string
  phonenumber: string
  password: string
  twoFactorType?: string
  councilsAcList?: []
  buildingsAcList?: []
}

export const getUserData = async (accessToken: string): Promise<UsersManagmentObject> => {
  const data = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  console.log('data', data)
  return data
}

export const userAddProfile = async (values: string): Promise<UsersManagmentAddObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const url = `${LOGINAPI_ADDRESS}/profile`
  // const url = `${LOGINAPI_ADDRESS}/api/users/profile`
  const { data } = await axios.post(url, values, config)
  return data
}

export const userUpdateProfile = async (values: string): Promise<UsersManagmentObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const url = `${LOGINAPI_ADDRESS}/general-profile`
  // const url = `${LOGINAPI_ADDRESS}/api/users/general-profile`
  // console.log("values", values)
  const { data } = await axios.put(url, values, config)
  return data
}

export const addCouncilPermission = async (_id: string, id: string, name: string): Promise<UsersManagmentObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  //   console.log(_id)
  //   console.log(id)
  //   console.log(name)
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  // const url = `${LOGINAPI_ADDRESS}/api/users/councils-access`
  const url = `${LOGINAPI_ADDRESS}/councils-access`
  const { data } = await axios.post(url, { _id, id, name }, config)
  console.log('councils-access', data);
  return data
}

export const removeCouncilPermission = async (_id: string, ownerId: string): Promise<UsersManagmentObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

  const url = `${LOGINAPI_ADDRESS}/councils-access`
  // const url = `${LOGINAPI_ADDRESS}/api/users/councils-access`

  const { data } = await axios.delete(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
    data: {
      _id,
      ownerId,
    },
  })

  return data
}

export const addBuildingPermission = async (
  _id: string,
  id: string,
  name: string,
  internalId: string,
): Promise<UsersManagmentObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const url = `${LOGINAPI_ADDRESS}/buildings-access`
  // const url = `${LOGINAPI_ADDRESS}/api/users/buildings-access`
  const { data } = await axios.post(url, { _id, id, name, internalId }, config)
  return data
}

export const removeBuildingPermission = async (_id: string, buildingId: string): Promise<UsersManagmentObject> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

  const url = `${LOGINAPI_ADDRESS}/buildings-access`
  // const url = `${LOGINAPI_ADDRESS}/api/users/buildings-access`

  const { data } = await axios.delete(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
    data: {
      _id,
      buildingId,
    },
  })

  return data
}
